/* eslint-disable no-undef */

// import { AnyAction } from 'redux'
import produce from 'immer'

export const SET_LAYER = 'SET_LAYER'
export const SET_CONFIRM = 'SET_CONFIRM'
export const SET_VALIDATION = 'SET_VALIDATION'
export const SET_SERVICE_ITEMS = 'SET_SERVICE_ITEMS'

export const layerAction = ({name,data}) => ({
    type: SET_LAYER,
    payload: {
        name,
        data: data || '' // null로 API 호출시 등록 실패
    }
})
export const layerConfirm = ({ name, data }) => {
    return {
        type: SET_CONFIRM,
        payload: {
            name,
            data: data || '' // null로 API 호출시 등록 실패
        }
    };
};
export const setServiceItems = ({data}) => ({
    type: SET_SERVICE_ITEMS,
    payload: {
        data: data
    }
})
export const validationAction = ({name,data}) => ({
    type: SET_VALIDATION,
    payload: {
        name,
        data: data || '' // null로 API 호출시 등록 실패
    }
})

export const initialState = {
    name: null,
    data: '', // null로 처리시 API 에러
    validation:{
        name:null,
        data:'',
    },
    confirm:{
        name:null,
        data:null,
    },
    service:{
        items: {
            basic:null,
            premium:null,
            install:null,
            installOs:null,
            installPc:null,
        }, //서비스 리스트
    }
}

export default (state = initialState, action) => {
    return produce(state, (draft) => {
        switch (action.type) {
            case SET_LAYER: {
                draft.name = action.payload.name
                draft.data = action.payload.data || ''
                break
            }
            case SET_CONFIRM: {
                draft.confirm.name = action.payload.name
                draft.confirm.data = action.payload.data || ''
                break
            }
            case SET_VALIDATION: {
                draft.validation.name = action.payload.name
                draft.validation.data = action.payload.data || ''
                break
            }
            case SET_SERVICE_ITEMS: {
                const data = action.payload.data
                const basic = data.basic
                const premium = data.premium
                const install = data.install
                install.forEach(data => {
                    const type = data.type;
                    if (type === 'install.os') {
                        draft.service.items.installOs = data;
                    }
                    if (type === 'install.visit') {
                        draft.service.items.installPc = data;
                    }
                });
                draft.service.items.basic = basic
                draft.service.items.premium = premium
                draft.service.items.install = install
                break
            }
            default: {
                break
            }
        }
    })
}



// WEBPACK FOOTER //
// ./src/estimate_list/reducers/service.js